import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useUser } from "src/atoms/user";
import { getLoginToken, pages, removeLoginToken } from "src/utils";
import { useNavigation } from "src/utils/navigation";
import { Page } from "../Page/Page";
import { PageStatus } from "../PageStatus/PageStatus";
import { Modals } from "../Modals/Modals";
import { useApi } from "src/api";
import { getRedirectUrl, setRedirectUrl } from "src/utils/sessionStorage";

export const IsAuthorized = () => {
  const { navigate } = useNavigation();
  const { getVerifyUserApi } = useApi();
  const { user, setUser } = useUser();

  useEffect(() => {
    if (!user) {
      verifyUser();
    }
  }, []);

  const verifyUser = async () => {
    // Save redirect url.
    if (getRedirectUrl() === null) {
      setRedirectUrl(window.location.pathname);
    }

    // Login token not found.
    if (!getLoginToken()) {
      navigate(pages.login);
      return;
    }

    // Login token found.
    const user = await getVerifyUserApi();

    // Login token expired.
    if (!user) {
      removeLoginToken();
      navigate(pages.login);
      return;
    }

    // Login token used and user verified.
    setUser(user);
  };

  // Pages needing authentication are rendered empty until user is verified.
  if (!user) {
    return null;
  }

  // Page content is only rendered once user is authorized.
  return (
    <>
      <Suspense
        fallback={
          <Page>
            <PageStatus label="Loading..." icon="spinner" />
          </Page>
        }
      >
        <Outlet />
      </Suspense>
      <Modals />
    </>
  );
};
